import {
  MAX_NUM_MULTIPLEX_UNITS_ERROR,
  MAX_NUM_MULTIPLEX_UNITS_VALUE,
  MAX_NUM_UNITS_ERROR,
  MAX_NUM_UNITS_VALUE,
  NUMBER_OF_UNITS_ERROR,
  POSITIVE_NUMBER_OF_UNITS_ERROR,
  PROPERTY_TYPES,
  UNIT_ALERT,
  UNIT_NUMBER_LENGTH_LIMIT,
  type UnitAlertValue,
} from '../constants';

import typeCheckUtils from './typeCheckUtils';

export const resolveUnitAlert = (
  data: { isValidatedWithoutUnit?: boolean; promptForUnit?: boolean },
  unit: string,
): UnitAlertValue | null => {
  if (unit && data.isValidatedWithoutUnit) return UNIT_ALERT.VALIDATED_WITHOUT_UNIT;
  if (!unit && data.promptForUnit) return UNIT_ALERT.PROMPT_FOR_UNIT;
  return null;
};

/**
 * Soft limit — over-length values are allowed into state so the user can see and fix them.
 * Callers pair this with `CharacterCountFormHelp` for display and block submit on `true`.
 */
export const isUnitNumberOverLimit = (unit?: string): boolean => (unit ?? '').length > UNIT_NUMBER_LENGTH_LIMIT;

const { COMMUNITY, MULTIPLEX } = PROPERTY_TYPES;

export const validateNumUnits = (numUnits: string, propertyType: string): string | null => {
  const requiresNumUnits = propertyType === COMMUNITY || propertyType === MULTIPLEX;

  if (!numUnits) {
    return requiresNumUnits ? 'Enter number of units' : null;
  }

  const isWholeNumber = typeCheckUtils.isNumeric(numUnits) && !numUnits.includes('.');
  if (!isWholeNumber) return NUMBER_OF_UNITS_ERROR;

  const value = Number(numUnits);
  if (value <= 0) return POSITIVE_NUMBER_OF_UNITS_ERROR;
  if (propertyType === MULTIPLEX && value > MAX_NUM_MULTIPLEX_UNITS_VALUE) return MAX_NUM_MULTIPLEX_UNITS_ERROR;
  if (propertyType === COMMUNITY && value > MAX_NUM_UNITS_VALUE) return MAX_NUM_UNITS_ERROR;

  return null;
};
